import { makeStyles } from "tss-react/mui"
import { lightBlue } from "../../themes/palette"
import { alpha } from "@mui/material"

export const useStyles = makeStyles()(({ spacing, breakpoints }) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    padding: spacing(5)
  },
  notFoundContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "400px",
    height: "400px",
    borderRadius: "50%",
    border: `1px solid ${lightBlue[300]}`,
    backgroundColor: alpha(lightBlue[50], 0.5),

    [breakpoints.down("sm")]: {
      width: "300px",
      height: "300px"
    }
  },
  notFoundImage: {
    marginBottom: spacing(5)
  }
}))
